export default __webpack_public_path__ + "static/media/leftLantern2056.87d9c05e.gif";